"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createStyle(doc, cssText) {
    var style = doc.createElement('style');
    style.type = 'text/css';
    style.appendChild(window.document.createTextNode(cssText));
    return style;
}
exports.createStyle = createStyle;
function createIFrame(parent) {
    if (parent === void 0) { parent = window.document.body; }
    var el = window.document.createElement('iframe');
    var css = 'visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;';
    el.setAttribute('src', 'about:blank');
    el.setAttribute('style', css);
    el.setAttribute('width', '0');
    el.setAttribute('height', '0');
    el.setAttribute('wmode', 'opaque');
    parent.appendChild(el);
    return el;
}
exports.createIFrame = createIFrame;
/** Printd class that prints HTML elements in a blank document */
var Printd = /** @class */ (function () {
    function Printd(parent) {
        if (parent === void 0) { parent = window.document.body; }
        var _this = this;
        this.parent = parent;
        this.loading = false;
        this.iframe = createIFrame(this.parent);
        this.iframe.addEventListener('load', function () { return _this.loadEvent(); }, false);
    }
    /** Gets current Iframe reference */
    Printd.prototype.getIFrame = function () {
        return this.iframe;
    };
    /**
     * Print an HTMLElement
     *
     * @param el HTMLElement
     * @param cssText Optional CSS Text that will add to head section of the iframe document
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.print = function (el, cssText, callback) {
        if (this.loading)
            return;
        var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow = _a.contentWindow;
        if (!contentDocument || !contentWindow)
            return;
        this.iframe.src = 'about:blank';
        this.elCopy = el.cloneNode(true);
        if (this.elCopy) {
            this.loading = true;
            this.callback = callback;
            var doc = contentWindow.document;
            doc.open();
            doc.write("\n        <!DOCTYPE html><html><head><meta charset=\"utf-8\"></head><body></body></html>\n      ");
            if (cssText) {
                doc.head.appendChild(createStyle(doc, cssText));
            }
            doc.body.appendChild(this.elCopy);
            doc.close();
        }
    };
    /**
     * Print an URL
     *
     * @param url URL to print
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.printURL = function (url, callback) {
        if (this.loading)
            return;
        this.loading = true;
        this.callback = callback;
        this.iframe.src = url;
    };
    Printd.prototype.launchPrint = function (contentWindow) {
        var result = contentWindow.document.execCommand('print', false, null);
        if (!result) {
            contentWindow.print();
        }
    };
    Printd.prototype.loadEvent = function () {
        var _this = this;
        if (this.iframe) {
            this.loading = false;
            var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow_1 = _a.contentWindow;
            if (!contentDocument || !contentWindow_1)
                return;
            if (this.callback) {
                this.callback({
                    iframe: this.iframe,
                    element: this.elCopy,
                    launchPrint: function () { return _this.launchPrint(contentWindow_1); }
                });
            }
            else {
                this.launchPrint(contentWindow_1);
            }
        }
    };
    return Printd;
}());
exports.Printd = Printd;
exports.default = Printd;



//////////////////
// WEBPACK FOOTER
// ./~/printd/index.js
// module id = 5OkI
// module chunks = 0